import React from 'react';
import MileageCalculator from './MileageCalculator';

function App() {
  return <MileageCalculator />;
}

export default App;

